import { useNotification } from '@gohighlevel/ghl-ui'
import { computed, inject, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { LocationServices, TemplateType } from '../services'

const loadingSmsTemplates = ref(false)
const smsTemplates: any = ref([])

export const useSMSTemplates = () => {
  const { t } = useI18n()
  const route = inject<any>('route')
  const notification = useNotification()

  const smsTemplateOptions = computed(() => {
    const options = smsTemplates?.value?.map((p: any) => ({
      label: p.name,
      value: p.id,
    }))
    options.unshift({
      label: t('common.default'),
      value: 'default',
    })
    return options
  })

  const getSMSTemplates = async (params: { locationId?: string }) => {
    try {
      loadingSmsTemplates.value = true
      const locationId = params?.locationId || route?.params?.location_id
      if (!locationId) return
      const { data } = await LocationServices.getTemplatesForLocationAndType(
        locationId,
        TemplateType.SMS
      )
      smsTemplates.value = data?.templates
    } catch (error: any) {
      let errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        t('invalid.listSMSTemplates')
      if (Array.isArray(errorMsg)) errorMsg = errorMsg.join(', ')
      notification.error({
        content: errorMsg,
        duration: 3000,
        keepAliveOnHover: true,
      })
    } finally {
      loadingSmsTemplates.value = false
    }
  }

  return {
    smsTemplateOptions,
    loadingSmsTemplates,
    smsTemplates,
    getSMSTemplates,
  }
}
